// extracted by mini-css-extract-plugin
export default {"container":"container__cNM52","dropdown":"dropdown__OnP9o"};